"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIPanel = _interopRequireDefault(require("UIComponents/panel/UIPanel"));

var _UIPanelHeader = _interopRequireDefault(require("UIComponents/panel/UIPanelHeader"));

var _UIPanelBody = _interopRequireDefault(require("UIComponents/panel/UIPanelBody"));

var _UIPanelSection = _interopRequireDefault(require("UIComponents/panel/UIPanelSection"));

var _UIPanelFooter = _interopRequireDefault(require("UIComponents/panel/UIPanelFooter"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var _EventBoundary = _interopRequireDefault(require("draft-plugins/components/EventBoundary"));

var _PromiseHandlers = require("UIComponents/core/PromiseHandlers");

var _QuestionEntityRecord = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionEntityRecord"));

var _QuestionAndAnswerForm = _interopRequireDefault(require("./QuestionAndAnswerForm"));

var _QuestionAndAnswerReplaceQuestionModal = _interopRequireDefault(require("./QuestionAndAnswerReplaceQuestionModal"));

var EventIsolatedUIPanel = (0, _EventBoundary.default)(_UIPanel.default);

var _default = (0, _createReactClass.default)({
  displayName: "QuestionAndAnswerPanel",
  propTypes: {
    properties: _propTypes.default.instanceOf(_immutable.Map).isRequired,
    question: _propTypes.default.instanceOf(_QuestionEntityRecord.default),
    saveQuestion: _propTypes.default.func.isRequired,
    onClose: _propTypes.default.func.isRequired
  },
  getInitialState: function getInitialState() {
    var question = this.props.question;
    return {
      isNew: !question,
      question: question || new _QuestionEntityRecord.default(),
      isSavingQuestion: false,
      showOverrideModal: false
    };
  },
  handleChange: function handleChange(updatedQuestion) {
    this.setState({
      question: updatedQuestion
    });
  },
  handleSave: function handleSave(_ref) {
    var _this = this;

    var _ref$createNew = _ref.createNew,
        createNew = _ref$createNew === void 0 ? false : _ref$createNew;
    this.setState({
      isSavingQuestion: true
    });
    var question = createNew ? this.state.question.merge({
      questionId: null,
      state: 'DRAFT',
      version: null
    }) : this.state.question;
    this.props.saveQuestion(question).then(function () {
      _this.props.onClose();
    }, function (error) {
      _FloatingAlertStore.default.addAlert({
        type: 'danger',
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: "composer-plugins.questionAndAnswer.alerts.unableToSaveTitle"
        }),
        message: _react.default.createElement(_FormattedMessage.default, {
          message: "composer-plugins.questionAndAnswer.alerts.unableToSaveMessage"
        })
      });

      _this.setState({
        isSavingQuestion: false
      });

      (0, _PromiseHandlers.rethrowError)(error);
    });
  },
  renderOverrideModal: function renderOverrideModal() {
    var _this2 = this;

    if (!this.state.showOverrideModal) {
      return null;
    }

    return _react.default.createElement(_QuestionAndAnswerReplaceQuestionModal.default, {
      showOverrideModal: this.state.showOverrideModal,
      closeOverrideModal: function closeOverrideModal() {
        return _this2.setState({
          showOverrideModal: false
        });
      },
      handleSave: this.handleSave
    });
  },
  renderHeader: function renderHeader() {
    var textPath = this.props.question ? 'composer-plugins.questionAndAnswer.editQuestionAndAnswer' : 'composer-plugins.questionAndAnswer.createQuestionAndAnswer';
    return _react.default.createElement(_UIPanelHeader.default, null, _react.default.createElement("h2", null, _react.default.createElement(_FormattedMessage.default, {
      message: textPath
    })));
  },
  renderBody: function renderBody() {
    var properties = this.props.properties;
    var _this$state = this.state,
        question = _this$state.question,
        isSavingQuestion = _this$state.isSavingQuestion;

    if (isSavingQuestion) {
      return _react.default.createElement(_UIPanelBody.default, null, _react.default.createElement(_UIPanelSection.default, null, _react.default.createElement(_UIFlex.default, {
        justify: "center",
        align: "center"
      }, _react.default.createElement(_UILoadingSpinner.default, {
        use: "success"
      }))));
    }

    return _react.default.createElement(_UIPanelBody.default, null, _react.default.createElement(_UIPanelSection.default, null, _react.default.createElement(_QuestionAndAnswerForm.default, {
      question: question,
      onChange: this.handleChange,
      properties: properties
    })));
  },
  renderSaveAsNewButton: function renderSaveAsNewButton() {
    var _this3 = this;

    if (this.state.isNew) {
      return null;
    }

    return _react.default.createElement(_UIButton.default, {
      use: "secondary",
      disabled: !this.state.question.isValid(),
      onClick: function onClick() {
        return _this3.setState({
          showOverrideModal: true
        });
      },
      "data-selenium-test": "question-and-answer-modal-save-button"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-plugins.questionAndAnswer.saveAsNew"
    }));
  },
  render: function render() {
    var _this4 = this;

    return _react.default.createElement(EventIsolatedUIPanel, {
      width: 450
    }, _react.default.createElement(_UIDialogCloseButton.default, {
      "data-onboarding-id": "question-panel-close-button",
      onClick: this.props.onClose
    }), this.renderHeader(), this.renderBody(), _react.default.createElement(_UIPanelFooter.default, null, _react.default.createElement(_UIButton.default, {
      use: "primary",
      disabled: !this.state.question.isValid(),
      onClick: function onClick() {
        return _this4.handleSave({
          createNew: _this4.state.isNew || !_this4.state.question.questionId
        });
      },
      "data-selenium-test": "question-and-answer-modal-save-button",
      "data-onboarding-id": "question-save-button"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-plugins.questionAndAnswer.save"
    })), this.renderSaveAsNewButton()), this.renderOverrideModal());
  }
});

exports.default = _default;
module.exports = exports.default;